import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="error-container">
      <div class="error-content">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h1 class="error-title">Error en el Proceso</h1>
        <p class="error-message">
          Ha ocurrido un error durante el proceso de pago. Por favor, inténtelo
          nuevamente.
        </p>
        <div class="error-actions">
          <button mat-raised-button color="primary" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Volver
          </button>
          <button mat-button (click)="goHome()">
            <mat-icon>home</mat-icon>
            Ir al Inicio
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  constructor(private router: Router) {}

  goBack(): void {
    window.history.back();
  }

  goHome(): void {
    void this.router.navigateByUrl('/');
  }
}
